

<app-enfaf-modal
  svgIcon="user-check-dark"
  [title]="title"
  buttonCancelText="Cancelar"
  (onClose)="confirmCloseModal()"
  buttonConfirmText="Guardar"
  (onConfirm)="assignMassiveCourse()"
  [isLoading]="isAssigning"
  [disableConfirmButton]="!csvToUpload || isAssigning"
>

 <div class="modal-content" autocomplete="off">

      <p>
        Para asignar este curso a muchos estudiantes a la vez, debes subir un archivo CSV que obligatoriamente tenga un campo llamado email.
      </p>

      <app-enfaf-input-file-dragger-light
        [acceptMultiple]="false"
        [acceptLimit]="1"
        [maxFileSize]="25000000"
        [accept]="'.csv'"
        (localFileDeleted)="onLocalFileDeleted()"
        (filesDropped)="onDroppedFiles($event)">
      </app-enfaf-input-file-dragger-light>

    </div>

</app-enfaf-modal>


